import * as Yup from "yup";

const organizationSchema = Yup.object().shape({
  country: Yup.string().trim().required("Country is required"),
  brand: Yup.string().trim().required("Brand is required"),
});

const loginSchema = Yup.object().shape({
  emailOrUserName: Yup.string()
    .trim()
    .required("Email or username is required"),
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
});

export { organizationSchema, loginSchema };
